import axios from 'axios';
import { API_BASE_V2 } from 'config/constants';

export const adminLookupUser = userString =>
  axios.get(`${API_BASE_V2}/admin/lookup`, {
    params: {
      user_identifier: userString
    }
  });
